import {
  AnyProjectUser,
  RemoteModulesInfo,
  RouteFilterProps,
  canRouteBeUsed,
  filterSubRoutes,
} from 'admin-web-utils'
import { orderBy } from 'lodash'
import React from 'react'
import { RouteRedirect } from '../../components/RouteRedirect'
import { FeatureFlag } from '../../feature-flags'
import * as Pages from '../../pages'
import { NewRouteDefinition } from '../../routes'
import { mapModuleToRoute } from './route-helpers'
import { getServiceRoutes } from './service-routes'

export type ProjectRouteDefinitionFactory = (
  remotes: RemoteModulesInfo,
  props: RouteFilterProps,
) => NewRouteDefinition

export function getProjectRoutesRoot(
  remotes: RemoteModulesInfo,
  props: RouteFilterProps,
): NewRouteDefinition[] {
  const modules = Object.values(remotes)
  const remoteRoutes = modules.map((module) => mapModuleToRoute(module, props))

  const sortedServiceRoutes = orderBy(
    [...getServiceRoutes(), ...remoteRoutes],
    'displayName',
    'asc',
  )

  return props.projectId
    ? [containerRoutes(), ...sortedServiceRoutes]
        .filter((route) => canRouteBeUsed(route, props))
        .map((route) => filterSubRoutes(route, props))
    : []
}

export const containerRoutes = (): NewRouteDefinition => ({
  path: 'overview',
  element: <RouteRedirect routePath="settings" />,
  displayName: 'Overview',
  iconPath: '/images/settings',
  usage: 'sidebar',
  requiredAuth: AnyProjectUser,
  routes: [
    {
      path: 'overview/settings',
      element: <Pages.ProjectSettings />,
      displayName: 'Settings',
      usage: 'sidebar',
    },
    {
      path: 'overview/user-lookup',
      element: <Pages.UserLookup />,
      displayName: 'User Lookup',
      usage: 'sidebar',
      // TODO: remove when support tools feature is in place.
      featureFlag: FeatureFlag.SUPPORT_TOOLS,
      // TODO: should this require the user service?
    },
  ],
})
